module.exports = __webpack_public_path__ + "assets/collegiatessinside-regular-webfont-fe55af81071b10dd5fb52d4887c8519e.svg";